import React from 'react';
import { SDG_IMAGES } from '../../../../constants/datas';
import AvatarImage from '../../../../ui/AvatarImage';
import BountyDescription from '../../../bounties/BountyDescription';
import { EarthIcon, FistIcon, SunIcon, WaterIcon } from '../../../../assets/icons/ProgressBarIcons';
import PdfHeaderComponent from './PdfHeaderComponent';

const coreIcons = {
    Earth: <EarthIcon key="earth-icon" color="" />,
    Energy: <SunIcon key="sun-icon" color="" />,
    Social: <FistIcon key="fist-icon" color="" />,
    Water: <WaterIcon key="wayer-icon" color="" />,
};

const ActivityPagesComponent = ({ activities = [], projectData }) => {
  // Group activities into pages of 2
  const activitiesPerPage = 2;
  const activityPages = [];
  
  for (let i = 0; i < activities.length; i += activitiesPerPage) {
    activityPages.push(activities.slice(i, i + activitiesPerPage));
  }
console.log(activities,"now solve this ")
  return (
    <>
      {activityPages.map((pageActivities, pageIndex) => (
        <div key={pageIndex} className="pdf-section pdf-page-break" style={{ paddingTop: '20px', paddingBottom: '40px', paddingLeft: '20px', paddingRight: '20px' }}>
          <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
          {pageIndex === 0 && (
            <h2 className="text-2xl font-semibold text-textPrimary mb-4">Activities</h2>
          )}
          
          {pageActivities.map((activity, activityIndex) => {
            const globalIndex = pageIndex * activitiesPerPage + activityIndex + 1;
            
            return (
              <div key={activity._id || activityIndex} className="mb-6 text-textPrimary">
                <h3 className="text-lg font-semibold text-textPrimary mb-3">
                  {globalIndex}. {activity.title}
                </h3>
                
                {/* Description */}
                <div className="flex items-baseline mb-2">
                  <span className="mr-2">•</span>
                  <div>
                    <span>Description- </span>
                    <BountyDescription 
                      htmlClassName="inline text-textPrimary text-sm leading-5 max-w-none" 
                      paragraphClassName='text-textPrimary text-sm inline' 
                      html={activity.description} 
                    />
                  </div>
                </div>

                {/* Two column layout for details */}
                <div className="grid grid-cols-2 gap-8">
                  {/* Left Column */}
                  <div className="space-y-2">
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Start Date- {activity.startDate || '9 January, 2024'}</span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>End Date- {activity.endDate || '9 December, 2024'}</span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Created by- {activity?.creator?.username || activity?.createdBy?.username || 'userxyz1'}</span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Validated by- {activity?.validators?.map((v, index) => <span key={v.uid || index}>{v.username || v}{index < activity.validators.length - 1 ? ', ' : ''}</span>)} </span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <div>
                        <span>Impact Cores- </span>
                        <div className='flex items-center gap-3 mt-1'>
                          {(activity?.cores || activity?.impactCores || ['Earth', 'Energy']).map((core) => 
                            <span key={core} className='flex items-center gap-1'>
                              <span style={{display: 'inline-flex', alignItems: 'center'}}>{coreIcons[core]}</span>
                              <span style={{verticalAlign: 'middle', lineHeight: '1'}}>{core}</span>
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <div>
                        <span>SDGs- </span>
                        <div className='flex gap-2 mt-2'>
                          {(activity?.SDGs || activity?.sdgs || [6, 11, 13]).slice(0, 3).map((sdg, index) => (
                            <img key={sdg + index} className="w-8 h-8" src={SDG_IMAGES[sdg]} alt={`SDG ${sdg}`} />
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <div>
                        <span>Media- </span>
                        <div className='my-2'>
                          {activity.media && activity.media.length > 0 ? (
                            <span>{activity.media.length} media file(s) attached</span>
                          ) : (
                            <span>No media files</span>
                          )}
                        </div>
                      </div>
                    </div>
                  
                  </div>

                  {/* Right Column */}
                  <div className="space-y-2 border-l border-gray-300 pl-8">
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Funds Deployed- ${activity.rewardAmountUSD || '500'}</span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Impact Points Accumulated- {activity.impactPoints || '5000'} IP</span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Participants- {activity.acceptorCount || '5000'}</span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Claims rewarded- {activity.claimsCount || '200'}</span>
                    </div>
                    <div className="flex items-baseline">
                      <span className="mr-2">•</span>
                      <span>Impact Certificates Issued- {activity.impactCertificatesCount || '400'}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};

export default ActivityPagesComponent;
